import { render, staticRenderFns } from "./userCoursePay.vue?vue&type=template&id=68536b4e&scoped=true"
import script from "./userCoursePay.vue?vue&type=script&lang=js"
export * from "./userCoursePay.vue?vue&type=script&lang=js"
import style0 from "./userCoursePay.vue?vue&type=style&index=0&id=68536b4e&prod&lang=scss"
import style1 from "./userCoursePay.vue?vue&type=style&index=1&id=68536b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68536b4e",
  null
  
)

export default component.exports